
import {Sale} from "@/models/base";
import Vue from "vue";
import {TranslateResult} from "vue-i18n";
import AppInvoiceListEntry from "./InvoiceListEntry.vue";
import AdditionalInvoiceList from "./AdditionalInvoiceList.vue";
import AppEstimateListEntry from "./EstimateListEntry.vue";
import AppInvoiceListHeader from "./InvoiceListHeader.vue";
import AppEstimateListHeader from "./EstimateListHeader.vue";
import {ClientPortalTabConfig} from "@/models/dossier-configs/client-portal-tab-config";
import {i18n} from "@/setup/i18n-setup";

export default Vue.extend({
	data() {
		return {
			showExpired: true,
			showEstimatesBlock: true,
			showOpen: true,
			showPayed: true,
			activeTab: 1,
			tab: ""
		};
	},
	props: {
		activeInvoice: {
			type: Array as () => Sale[],
			required: true
		},
		openInvoices: {
			type: Array as () => Sale[],
			required: true
		},
		openEstimates: {
			type: Array as () => Sale[],
			required: true
		},
		closedEstimates: {
			type: Array as () => Sale[],
			required: true
		},
		expiredInvoices: {
			type: Array as () => Sale[],
			required: true
		},
		additionalSales: {
			type: Array as () => Sale[],
			required: true
		},
		invoices: {
			type: Array as () => Sale[],
			required: true
		},
		signableTypes: {
			type: Array as () => String[],
			required: false
		},
		token: {
			type: String,
			required: true
		},
		canPay: {
			type: Boolean,
			required: true
		},
		showEstimates: {
			type: Boolean,
			required: false
		},
		config: {
			type: Array as () => ClientPortalTabConfig[],
			required: true
		}
	},
	computed: {
		tabs(): TranslateResult[] {

			/*let a = [
				this.$ct("tabs.overview"),
				this.$ct("tabs.unpaid",{count: (this.totalItemsToPay > 0 ? "<span class='count urgent'>"+this.totalItemsToPay+"</span>" : "")}),
				this.$ct("tabs.paid"),

			];

			if(this.showEstimates){
				a.push(this.$ct("tabs.open-offers",
					{count: (this.openEstimates.length > 0 ? "<span class='count attention'>"+this.openEstimates.length+"</span>" : "")}),this.$ct("tabs.accepted-offers"));
			}

			const uniqueDisplayedNames = [...new Set(this.additionalSales.map(sale => sale.Type.DisplayedName))];
			a.push(...uniqueDisplayedNames);

			return a.map(t=>t.toString());*/

			let a = this.config.filter((t: ClientPortalTabConfig)=>t.Visible).map((t: ClientPortalTabConfig) => {
				let n = t.Name.getTranslation(i18n.locale);
				if(t.ID == "unpaid"){
					n = t.Name.getTranslation(i18n.locale) +  (this.totalItemsToPay > 0 ? "<span class='count urgent'>"+this.totalItemsToPay+"</span>" : "");
				}
				return n;
			});

			return a.map(t => t.toString());

		},
		totalItemsToPay(): number {
			return this.expiredInvoices.length + this.openInvoices.length;
		},
		additionalSalesPerType(): any {
			/*return this.additionalSales.reduce((acc, sale) => {
				if (!acc[sale.TypeID]) {
					acc[sale.TypeID] = [];
				}
				acc[sale.TypeID].push(sale);
				return acc;
			}, {} as any);*/
			return this.additionalSales.reduce((acc, sale) => {
				const filterSetting = this.splitSignedDocuments(sale.TypeID);
				if (!acc[sale.TypeID]) {
					acc[sale.TypeID] = filterSetting
						? { signed: [], unsigned: [] }
						: [];
				}
				if (filterSetting) {
					if (sale.SignedOnDate) {
						acc[sale.TypeID].signed.push(sale);
					} else {
						acc[sale.TypeID].unsigned.push(sale);
					}
				} else {
					acc[sale.TypeID].push(sale);
				}
				return acc;
			}, {} as any);
		},
	},
	watch: {
		activeTab(){
			this.tab = this.config.filter(f => f.Visible)[this.activeTab].TypeID
				? ("tab"+this.config.filter(f => f.Visible)[this.activeTab].TypeID)
				: this.config.filter(f => f.Visible)[this.activeTab].ID.toString();
		}
	},
	methods: {
		canBeSignedByClient(TypeID: number): boolean{
			return this.signableTypes?.includes(TypeID.toString()); //DossierConfigService.getSaleConfig(TypeID).CanBeSignedByClient || false;
		},
		additionalTabName(TypeID: number):string{
			return this.config.filter((c)=>c.TypeID == TypeID)[0].Name.getTranslation(i18n.locale).toString();
		},
		showOnOverview(id:string){
			return this.tab=="overview" && this.config.filter((c) => (c.ID == id || "tab"+c.TypeID == id))[0].ShowInOverview;
		},
		splitSignedDocuments(id:number){
			return this.config.filter((c) => (c.TypeID == id))[0].ShowToSignInSeperateWindow;
		},
		invoiceClicked(invoice: Sale) {
			this.$emit("invoice-clicked", invoice);
		},
		onScroll(event: Event) {
			if (!event.target) return;
			let target = event.target as HTMLElement;
			if (target.scrollHeight - (target.scrollTop + target.clientHeight) < 40) {
				this.$emit("fetch");
			}
		},
		getChevron(open: boolean): string {
			if (open) {
				return "chevron-up";
			}
			return "chevron-down";
		},
		getCollapseTooltip(open: boolean): TranslateResult {
			if (open) {
				return this.$ct("collapse-list");
			}
			return this.$ct("expand-list");
		},
		estimateSignClicked(estimate: Sale) {
			this.$emit("estimate-sign-clicked", estimate);
		},
		getInfo(TypeID:any): String{
			let i = this.config.filter((c)=>c.TypeID == TypeID || (c.TypeID == 0 && c.ID == TypeID))[0]
				? this.config.filter((c)=>c.TypeID == TypeID || (c.TypeID == 0 && c.ID == TypeID))[0].Info : null;
			return i ? i : "";
		},
		getTitle(TypeID:any): String{
			let i = this.config.filter((c)=>c.TypeID == TypeID || (c.TypeID == 0 && c.ID == TypeID))[0]
				? this.config.filter((c)=>c.TypeID
					== TypeID || (c.TypeID == 0 && c.ID
						== TypeID))[0].SeperateWindowTitle.getTranslation(i18n.locale).toString() : null;
			return i ? i : "";
		}
	},
	async created() {
		this.activeTab = 0;
	},
	components: {
		AppInvoiceListEntry,
		AppInvoiceListHeader,
		AppEstimateListEntry,
		AppEstimateListHeader,
		AdditionalInvoiceList
	},
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
});
